let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bv8GZ")).then(() => parcelRequire('74xff'));